import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Details from 'components/common/Details/Details'
import { arrayHasValues } from 'helpers/utils'

const TireSpecification = ({ title, specification = [], hideCaption = false }) =>
  <Fragment>
    {
      !hideCaption &&
        <Caption data-at-specifications-caption>Specifications</Caption>
    }
    {
      title &&
        <Title data-at-specifications-title>{ title }:</Title>
    }
    {
      arrayHasValues(specification) &&
      <SpecificationsWrapper data-at-specifications>
        {
          specification.map(({ specName, specValue }, index) =>
            <Details title={ specName } key={ index } clear >{ specValue }</Details>
          )
        }
      </SpecificationsWrapper>
    }
  </Fragment>

TireSpecification.propTypes = {
  hideCaption: PropTypes.bool,
  specification: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

export default TireSpecification

const SpecificationsWrapper = styled.dl`
  ${Media.mobile`
    & {
      dt, dd {
        font-size: 12px;
      }
      dt {
        width: 85px;
        padding: 5px 5px 5px 0;
      }
      dd {
        width: calc(100% - 85px);
        padding: 5px 0;
      }
    }
  `}
`

const Title = styled.div`
  ${Mixin.font.GothamBold()}
  line-height: 22px;
  padding: 5px 0;
`

const Caption = styled.p`
  margin-top: 0;
  margin-bottom: 10px;
  ${Mixin.font.GothamBold()}
`
